export const frontmatter = {
    "draft": true,
    "title": "Integración Google",
    "description": "Autenticación y acceso a OnnIA mediante cuenta de Google.",
    "sidebar_label": "Google",
    "sidebar_group": "guías",
    "sidebar_order": 4
}

export const toc = []